import styled from 'styled-components';

export const SellersContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: 16px;

  
`;

